import axios from "axios";

const API_URL = "/user-history/getAllMediasByUserId";

export const userHistoryApi = async (userId) => {
  try {
    const response = await axios.post(API_URL, { user_id: userId });
    const resObj = Object.values(response?.data?.data || {});
    const sortedResObjDesc = resObj.sort((a, b) => b.id - a.id);

    return sortedResObjDesc.length ? sortedResObjDesc : [];
  } catch (error) {
    console.log("ERROR WHILE FETCHING USER HISTORY user-history-api",err)
    console.error("Error fetching user media:", error);
    return [];
  }
};
